<template>
  <div>
    <v-row class="d-flex ma-3">
      <v-col cols="6">
        <date-filter store="regie" periodType="past-only" />
      </v-col>
      <v-col cols="3">
        <v-switch
          v-model="groupByMonth"
          label="Par mois"
          outlined
          dense
        ></v-switch>
      </v-col>
      <v-col class="d-flex">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed, onMounted, watch } from "@vue/composition-api";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    DateFilter,
  },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { isLoading } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    // =>  METHODS

    // =>  COMPUTED
    const groupByMonth = computed({
      get: () => store.getters["regie/getGroupByMonth"],
      set(e) {
        store.dispatch("regie/updateGroupByMonth", e);
      },
    });

    // =>  WATCH
    watch(groupByMonth, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES["GroupByMonthFilter"],
        value: newValue,
        // is_multiple: false,
        // is_integer: false,
        is_boolean: true,
      });
    });

    // =>  HOOKS
    onMounted(async () => {
      await synchronizeFilterWithQueryString({
        dispatcher: "regie/updateGroupByMonth",
        param: URL_PARAM_NAMES["GroupByMonthFilter"],
        value: groupByMonth.value,
        // is_multiple: false,
        // is_integer: false,
        is_boolean: true,
        // dependsOn: undefined,
      });
    });

    // =>  DATA
    return {
      isLoading,
      groupByMonth,
    };
  },
};
</script>

<style></style>
